class Slider extends HTMLElement {
  connectedCallback() {
    window.addEventListener('load', () => {
      this.initSlider()
    })
    window.addEventListener('shopify:section:load', () => {
      this.initSlider()
    })
    if (document.readyState === 'complete' && !this.swiper) {
      this.initSlider()
    }
  }

  disconnectedCallback() {
    this.swiper.destroy()
  }

  initSlider() {
    const options = this.dataset.options && JSON.parse(this.dataset.options)
    this.swiper = new window.Swiper(
      this,
      options || {
        slidesPerView: 1,
        autoplay: {
          delay: parseFloat(this.dataset.autoplay) * 1000 || 5000,
          disableOnInteraction: true,
          pauseOnMouseEnter: true,
        },
        navigation: this.dataset.navigation
          ? {
              nextEl: '.swiper-button-next',
              prevEl: '.swiper-button-prev',
            }
          : false,
        loop: this.dataset.loop,
      }
    )
  }
}

customElements.define('component-slider', Slider)
